import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderSlot as _renderSlot, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "py-3" }
const _hoisted_2 = { class: "text-h6" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Buscar ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Limpiar ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Descargar ")
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/_createVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_card_section = _resolveComponent("q-card-section")
  const _component_q_separator = _resolveComponent("q-separator")
  const _component_q_btn = _resolveComponent("q-btn")
  const _component_q_card = _resolveComponent("q-card")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_Transition, {
      name: "fade",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        _withDirectives(_createVNode(_component_q_card, {
          flat: "",
          tile: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _createVNode("div", _hoisted_2, _toDisplayString(_ctx.titulo), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_q_separator),
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _renderSlot(_ctx.$slots, "filtros", { filtro: _ctx.filtro }),
                _createVNode(_component_q_btn, {
                  class: "q-ma-md",
                  ref: "buscar",
                  loading: _ctx.loading,
                  disabled: _ctx.loading,
                  color: "secondary",
                  onClick: _ctx.buscar
                }, {
                  default: _withCtx(() => [
                    _hoisted_3
                  ]),
                  _: 1
                }, 8, ["loading", "disabled", "onClick"]),
                _createVNode(_component_q_btn, {
                  class: "q-ma-md",
                  disabled: _ctx.loading,
                  color: "primary",
                  onClick: _ctx.limpiar
                }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1
                }, 8, ["disabled", "onClick"]),
                (_ctx.tieneDescarga)
                  ? (_openBlock(), _createBlock(_component_q_btn, {
                      key: 0,
                      class: "q-ma-md",
                      ref: "descargar",
                      loading: _ctx.loading,
                      disabled: _ctx.loading,
                      color: "secondary",
                      onClick: _ctx.descargar
                    }, {
                      default: _withCtx(() => [
                        _hoisted_5
                      ]),
                      _: 1
                    }, 8, ["loading", "disabled", "onClick"]))
                  : _createCommentVNode("", true),
                _createVNode(_Transition, {
                  name: "fade",
                  mode: "out-in"
                }, {
                  default: _withCtx(() => [
                    (_ctx.page.data)
                      ? (_openBlock(), _createBlock("div", _hoisted_6, [
                          _hoisted_7,
                          _renderSlot(_ctx.$slots, "listados", {
                            loading: _ctx.loading,
                            pagination: _ctx.page.pagination,
                            data: _ctx.page.data,
                            filtro: _ctx.filtro,
                            totalItems: _ctx.totalItems
                          })
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 3
                })
              ]),
              _: 3
            })
          ]),
          _: 1
        }, 512), [
          [_vShow, _ctx.showBusqueda]
        ])
      ]),
      _: 1
    })
  ]))
}